"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BEDROCK_VISION_IMAGE_MAX_SIDE_PX = exports.BEDROCK_VISION_IMAGE_MAX_BYTES = void 0;
exports.imageExceedsBedrockVisionByteLimit = imageExceedsBedrockVisionByteLimit;
exports.imageExceedsBedrockVisionPixelLimit = imageExceedsBedrockVisionPixelLimit;
exports.BEDROCK_VISION_IMAGE_MAX_BYTES = Math.floor(3.75 * 1024 * 1024);
exports.BEDROCK_VISION_IMAGE_MAX_SIDE_PX = 8000;
function imageExceedsBedrockVisionByteLimit(size) {
    return size > exports.BEDROCK_VISION_IMAGE_MAX_BYTES;
}
function imageExceedsBedrockVisionPixelLimit(width, height) {
    return (width > exports.BEDROCK_VISION_IMAGE_MAX_SIDE_PX ||
        height > exports.BEDROCK_VISION_IMAGE_MAX_SIDE_PX);
}
//# sourceMappingURL=bedrock-vision-limits.js.map